import { render, staticRenderFns } from "./AutomationEngineSharedHeader.vue?vue&type=template&id=545ee3cb&scoped=true"
import script from "./AutomationEngineSharedHeader.vue?vue&type=script&lang=js"
export * from "./AutomationEngineSharedHeader.vue?vue&type=script&lang=js"
import style0 from "./AutomationEngineSharedHeader.vue?vue&type=style&index=0&id=545ee3cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545ee3cb",
  null
  
)

export default component.exports